module.exports = __webpack_public_path__ + "img/7.75844425.png";